module.exports = __webpack_public_path__ + "img/di14.8ee47cf6.png";